import { render, staticRenderFns } from "./ProjectBox.vue?vue&type=template&id=148e6f18&scoped=true"
import script from "./ProjectBox.vue?vue&type=script&lang=js"
export * from "./ProjectBox.vue?vue&type=script&lang=js"
import style0 from "./ProjectBox.vue?vue&type=style&index=0&id=148e6f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e6f18",
  null
  
)

export default component.exports